import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6025404f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row lockHeader" }
const _hoisted_2 = { class: "subheader col-6" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = {
  key: 0,
  class: "badge badge-dark fw-400 l-h-n"
}
const _hoisted_5 = {
  key: 1,
  class: "badge badge-info fw-400 l-h-n"
}
const _hoisted_6 = {
  key: 2,
  class: "badge badge-success fw-400 l-h-n"
}
const _hoisted_7 = {
  key: 3,
  class: "badge badge-danger fw-400 l-h-n"
}
const _hoisted_8 = { class: "subheader-block ml-auto demo lh-btnflm" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lockHeaderSpacer" }, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_21 = { class: "d-flex flex-start w-100" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
  ])
], -1))
const _hoisted_23 = { class: "d-flex flex-fill" }
const _hoisted_24 = { class: "flex-fill" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h5" }, "あなたが承認者です", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " この申請書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。 ", -1))
const _hoisted_27 = { class: "m-0" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20px"} }, " 　", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1))
const _hoisted_31 = {
  key: 1,
  class: "alert alert-primary"
}
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-6025404f><div class=\"mr-2 hidden-md-down\" data-v-6025404f><span class=\"icon-stack icon-stack-lg\" data-v-6025404f><i class=\"fal fa-info-circle\" data-v-6025404f></i></span></div><div class=\"d-flex flex-fill\" data-v-6025404f><div class=\"flex-fill\" data-v-6025404f><span class=\"h5\" data-v-6025404f>この申請書は承認依頼中です</span><p data-v-6025404f> この申請書は承認依頼中です。お急ぎの場合は、承認者にご連絡ください。 </p></div></div></div>", 1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-6025404f><div class=\"mr-2 hidden-md-down\" data-v-6025404f><span class=\"icon-stack icon-stack-lg\" data-v-6025404f><i class=\"fal fa-info-circle\" data-v-6025404f></i></span></div><div class=\"d-flex flex-fill\" data-v-6025404f><div class=\"flex-fill\" data-v-6025404f><span class=\"h5\" data-v-6025404f>この申請書は差戻しされました</span><p data-v-6025404f> この申請書は承認権者により差戻しされています。差戻し理由を確認の上、再度新しく申請書を作成してください。 </p></div></div></div>", 1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 3,
  class: "alert alert-primary"
}
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-6025404f><div class=\"mr-2 hidden-md-down\" data-v-6025404f><span class=\"icon-stack icon-stack-lg\" data-v-6025404f><i class=\"fal fa-info-circle\" data-v-6025404f></i></span></div><div class=\"d-flex flex-fill\" data-v-6025404f><div class=\"flex-fill\" data-v-6025404f><span class=\"h5\" data-v-6025404f>この申請書は取り下げられました</span><p data-v-6025404f> この申請書は申請者により取り下げられています。管理権限者はこの申請書を削除する事ができます。 </p></div></div></div>", 1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-xl-12" }
const _hoisted_42 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "申請時用"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_44 = { class: "panel-container show" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_46 = { class: "panel-content contents" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請番号", -1))
const _hoisted_49 = { class: "col-md-5 contCnt" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-5 contCnt" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_54 = { class: "row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "管理名", -1))
const _hoisted_56 = { class: "col-md-5 contCnt" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = { class: "col-md-5 contCnt" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_62 = { class: "row" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請日時", -1))
const _hoisted_64 = { class: "col-md-5 contCnt" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-md-5 contCnt" }
const _hoisted_67 = ["value"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "申請者", -1))
const _hoisted_72 = { class: "col-md-5 contCnt" }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-md-5 contCnt" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 contCnt" }, null, -1))
const _hoisted_77 = {
  class: "row",
  style: {"border-top":"1px solid #e5e5e5","padding-top":"10px","margin-bottom":"0"}
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "期間", -1))
const _hoisted_79 = { class: "col-md-5 contCnt" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col contCnt" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "alert border-info bg-transparent text-info fade show",
      style: {"padding-top":"0.5rem","padding-bottom":"0.5rem"},
      role: "alert"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fal fa-exclamation-circle",
          style: {"font-size":"18px","padding-right":"4px"}
        }),
        /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
          /*#__PURE__*/_createElementVNode("span", {
            class: "m-0 fw-700",
            style: {"font-size":"12px"}
          }, "1日以上の休暇の場合は下記に開始年月日と終了年月日を入力してください。 ")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col contCnt input-daterange input-group" }
const _hoisted_83 = {
  class: "input-daterange input-group",
  id: "datepicker-5"
}
const _hoisted_84 = ["disabled"]
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text fs-xl" }, "－")
], -1))
const _hoisted_86 = ["disabled"]
const _hoisted_87 = { class: "dateError" }
const _hoisted_88 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_89 = {
  key: 1,
  class: "error-message4vali"
}
const _hoisted_90 = {
  key: 2,
  class: "error-message4vali"
}
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-md-5 contCnt input-group radiuszero" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "日間")
], -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"border-top":"1px solid #e5e5e5","padding-top":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col contCnt" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "alert border-info bg-transparent text-info fade show",
      style: {"padding-top":"0.5rem","padding-bottom":"0.5rem"},
      role: "alert"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fal fa-exclamation-circle",
          style: {"font-size":"18px","padding-right":"4px"}
        }),
        /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
          /*#__PURE__*/_createElementVNode("span", {
            class: "m-0 fw-700",
            style: {"font-size":"12px"}
          }, "半休の場合は下記に年月日と午前休または午後休のいずれかを入力してください。 ")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-md-5 contCnt" }
const _hoisted_98 = ["disabled"]
const _hoisted_99 = { class: "col-md-5 contCnt" }
const _hoisted_100 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdGozen"
}, "午前休", -1))
const _hoisted_103 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_104 = ["disabled"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdGogo"
}, "午後休", -1))
const _hoisted_106 = { class: "partTypeError" }
const _hoisted_107 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_108 = { class: "row" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "区分", -1))
const _hoisted_110 = { class: "col-md-5 contCnt mt-2" }
const _hoisted_111 = { class: "row" }
const _hoisted_112 = { class: "col-md-auto contCnt" }
const _hoisted_113 = { class: "custom-control custom-radio" }
const _hoisted_114 = ["disabled"]
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdYukyu"
}, "有給休暇", -1))
const _hoisted_116 = { class: "custom-control custom-radio" }
const _hoisted_117 = ["disabled"]
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdSanzensango"
}, "産前産後休暇", -1))
const _hoisted_119 = { class: "custom-control custom-radio" }
const _hoisted_120 = ["disabled"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdNenjiyukyu"
}, "年次有給", -1))
const _hoisted_122 = { class: "custom-control custom-radio" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdDaikyu"
}, "代休・振替", -1))
const _hoisted_125 = { class: "col-md-auto contCnt" }
const _hoisted_126 = { class: "custom-control custom-radio" }
const _hoisted_127 = ["disabled"]
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdSeiri"
}, "生理休暇", -1))
const _hoisted_129 = { class: "custom-control custom-radio" }
const _hoisted_130 = ["disabled"]
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdTenkin"
}, "転勤休暇", -1))
const _hoisted_132 = { class: "custom-control custom-radio" }
const _hoisted_133 = ["disabled"]
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdKeiji"
}, "慶弔休暇", -1))
const _hoisted_135 = { class: "custom-control custom-radio" }
const _hoisted_136 = ["disabled"]
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdTokubetsu"
}, "特別休暇", -1))
const _hoisted_138 = { class: "col-md-auto contCnt" }
const _hoisted_139 = { class: "custom-control custom-radio" }
const _hoisted_140 = ["disabled"]
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "rdKaki"
}, "夏期休暇", -1))
const _hoisted_142 = { class: "custom-control custom-radio custom-control-inline mb-3" }
const _hoisted_143 = ["disabled"]
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label mr-3",
  for: "rdSonota"
}, "その他", -1))
const _hoisted_145 = ["disabled"]
const _hoisted_146 = { class: "holidayTypeError" }
const _hoisted_147 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_148 = { class: "row" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "事由", -1))
const _hoisted_150 = { class: "col-md-5 contCnt" }
const _hoisted_151 = { class: "row" }
const _hoisted_152 = { class: "col-md contCnt" }
const _hoisted_153 = ["disabled"]
const _hoisted_154 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_155 = { class: "row" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "備考", -1))
const _hoisted_157 = { class: "col-md-5 contCnt" }
const _hoisted_158 = { class: "row" }
const _hoisted_159 = { class: "col-md contCnt" }
const _hoisted_160 = ["disabled"]
const _hoisted_161 = { class: "row" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "第一承認", -1))
const _hoisted_163 = { class: "col-md-5 contCnt" }
const _hoisted_164 = { class: "row" }
const _hoisted_165 = { class: "col-md-5 contCnt" }
const _hoisted_166 = ["value"]
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1))
const _hoisted_168 = { class: "col-md-5 contCnt" }
const _hoisted_169 = ["value"]
const _hoisted_170 = { class: "row" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "第二承認", -1))
const _hoisted_172 = { class: "col-md-5 contCnt" }
const _hoisted_173 = { class: "row" }
const _hoisted_174 = { class: "col-md-5 contCnt" }
const _hoisted_175 = ["value"]
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1))
const _hoisted_177 = { class: "col-md-5 contCnt" }
const _hoisted_178 = ["value"]
const _hoisted_179 = { class: "row" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "最終承認", -1))
const _hoisted_181 = { class: "col-md-5 contCnt" }
const _hoisted_182 = { class: "row" }
const _hoisted_183 = { class: "col-md-5 contCnt" }
const _hoisted_184 = ["value"]
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "承認日時", -1))
const _hoisted_186 = { class: "col-md-5 contCnt" }
const _hoisted_187 = ["value"]
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1))
const _hoisted_189 = { class: "text-success fw-500" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_194 = { class: "modal-footer" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_197 = { class: "modal-footer" }
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_200 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", {
    id: "js-page-content",
    role: "main",
    class: _normalizeClass(["page-content", {
      isEdit: _ctx.isEditMode,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _createTextVNode(" 休暇届 "),
          (_ctx.delegate.request.c_request_status == 4)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_4, "取下"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 1)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_5, "申請中"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 3)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_6, "承認済"))
            : _createCommentVNode("", true),
          (_ctx.delegate.request.c_request_status == 2)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_7, "差戻"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-success waves-effect waves-themed",
              disabled: _ctx.btnDisable,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dl()))
            }, [
              _hoisted_10,
              _createTextVNode("Excel出力 ")
            ], 8, _hoisted_9))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-info waves-effect waves-themed",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
            }, [
              _hoisted_12,
              _createTextVNode("登録 ")
            ], 8, _hoisted_11))
          : _createCommentVNode("", true),
        (
            _ctx.isEditMode &&
            (_ctx.isAdmin || _ctx.isMine) &&
            _ctx.delegate.request.c_request_status != 4
          )
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-warning waves-effect waves-themed",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disableConf()))
            }, [
              _hoisted_14,
              _createTextVNode("取下 ")
            ], 8, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.isEditMode && _ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-danger waves-effect waves-themed",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.delConf()))
            }, [
              _hoisted_16,
              _createTextVNode("削除 ")
            ], 8, _hoisted_15))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/shinseisyolist')))
        }, [
          _hoisted_18,
          _createTextVNode("戻る ")
        ], 8, _hoisted_17)
      ])
    ]),
    _hoisted_19,
    (_ctx.fmShowConf)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("p", _hoisted_27, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info waves-effect waves-themed",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.upd4Approval(true)))
                  }, [
                    _hoisted_28,
                    _createTextVNode("承認 ")
                  ]),
                  _hoisted_29,
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger waves-effect waves-themed",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.upd4Approval(false)))
                  }, [
                    _hoisted_30,
                    _createTextVNode("差戻 ")
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fmShowConfEx)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
      : _createCommentVNode("", true),
    (_ctx.fmShowSasimodosi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
      : _createCommentVNode("", true),
    (_ctx.fmShowTorisage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaCd",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delegate.request.c_request_id) = $event)),
                        disabled: ""
                      }, null, 512), [
                        [_vModelText, _ctx.delegate.request.c_request_id]
                      ])
                    ]),
                    _hoisted_52,
                    _hoisted_53
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: "xxxx案件でyyyy作業の為",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.delegate.request.c_request_name) = $event))
                      }, null, 8, _hoisted_59), [
                        [_vModelText, _ctx.delegate.request.c_request_name]
                      ])
                    ]),
                    _hoisted_60,
                    _hoisted_61
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        maxlength: "10",
                        value: 
                          _ctx.convDateTime(_ctx.delegate.request.c_request_datetime)
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_67)
                    ]),
                    _hoisted_68,
                    _hoisted_69
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      (_ctx.isAdmin && !_ctx.isEditMode)
                        ? (_openBlock(), _createBlock(_component_vSelect, {
                            key: 0,
                            options: _ctx.getOpStaffs(),
                            label: "c_staff_name",
                            modelValue: _ctx.delegate.request.c_staff_id,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate.request.c_staff_id) = $event)),
                            reduce: (label) => label.c_staff_id
                          }, null, 8, ["options", "modelValue", "reduce"]))
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            type: "text",
                            name: "txtKouzaCd",
                            class: "form-control form-control-sm",
                            disabled: "",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.domApplicantName) = $event))
                          }, null, 512)), [
                            [_vModelText, _ctx.domApplicantName]
                          ])
                    ]),
                    _hoisted_75,
                    _hoisted_76
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm",
                          name: "start",
                          id: "dateStart",
                          ref: "dateStart",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.domDateholiday_start) = $event)),
                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.calculateDateDifference()))
                        }, null, 40, _hoisted_84), [
                          [_vModelText, _ctx.domDateholiday_start]
                        ]),
                        _hoisted_85,
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control form-control-sm",
                          name: "end",
                          id: "dateEnd",
                          ref: "dateEnd",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.domDateholiday_end) = $event)),
                          onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.calculateDateDifference()))
                        }, null, 40, _hoisted_86), [
                          [_vModelText, _ctx.domDateholiday_end]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    (_ctx.errors?.path === 'holiday_period')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(_ctx.errors.message), 1))
                      : _createCommentVNode("", true),
                    (_ctx.errors?.path === 'startDate')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, _toDisplayString(_ctx.errors.message), 1))
                      : _createCommentVNode("", true),
                    (_ctx.errors?.path === 'endDate')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_ctx.errors.message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.domholiday_days) = $event))
                      }, null, 8, _hoisted_93), [
                        [_vModelText, _ctx.domholiday_days]
                      ]),
                      _hoisted_94
                    ])
                  ]),
                  _hoisted_95,
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-control form-control-sm",
                        id: "datePart",
                        ref: "datePart",
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.domDateholiday_part) = $event)),
                        onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearDate()))
                      }, null, 40, _hoisted_98), [
                        [_vModelText, _ctx.domDateholiday_part]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdGozen",
                          name: "radioDaikyu",
                          class: "custom-control-input",
                          value: "1",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.delegate.c_request_holiday_part_type) = $event)),
                          onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearDate()))
                        }, null, 40, _hoisted_101), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_part_type]
                        ]),
                        _hoisted_102
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdGogo",
                          name: "radioDaikyu",
                          class: "custom-control-input",
                          value: "2",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.delegate.c_request_holiday_part_type) = $event)),
                          onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.clearDate()))
                        }, null, 40, _hoisted_104), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_part_type]
                        ]),
                        _hoisted_105
                      ]),
                      _createElementVNode("div", _hoisted_106, [
                        (_ctx.errors?.path === 'partType')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_107, _toDisplayString(_ctx.errors.message), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_108, [
                _hoisted_109,
                _createElementVNode("div", _hoisted_110, [
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("div", _hoisted_113, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdYukyu",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "1",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_114), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_115
                      ]),
                      _createElementVNode("div", _hoisted_116, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdSanzensango",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "2",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_117), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_118
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdNenjiyukyu",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "3",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_120), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_121
                      ]),
                      _createElementVNode("div", _hoisted_122, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdDaikyu",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "4",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_123), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_124
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_125, [
                      _createElementVNode("div", _hoisted_126, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdSeiri",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "5",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_127), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_128
                      ]),
                      _createElementVNode("div", _hoisted_129, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdTenkin",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "6",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_130), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_131
                      ]),
                      _createElementVNode("div", _hoisted_132, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdKeiji",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "7",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_133), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_134
                      ]),
                      _createElementVNode("div", _hoisted_135, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdTokubetsu",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "8",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_136), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_137
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdKaki",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "10",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_140), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_141
                      ]),
                      _createElementVNode("div", _hoisted_142, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "rdSonota",
                          name: "radioGenre",
                          class: "custom-control-input",
                          value: "9",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.delegate.c_request_holiday_type) = $event))
                        }, null, 8, _hoisted_143), [
                          [_vModelRadio, _ctx.delegate.c_request_holiday_type]
                        ]),
                        _hoisted_144,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "col form-control form-control-sm",
                          disabled: _ctx.isEditMode,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.domHoliday_type_oth) = $event))
                        }, null, 8, _hoisted_145), [
                          [_vModelText, _ctx.domHoliday_type_oth]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_146, [
                        (_ctx.errors?.path === 'holidayType')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_147, _toDisplayString(_ctx.errors.message), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_148, [
                _hoisted_149,
                _createElementVNode("div", _hoisted_150, [
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("div", _hoisted_152, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        rows: "5",
                        style: {"margin-bottom":"5px"},
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.domReason) = $event))
                      }, "\n                      ", 8, _hoisted_153), [
                        [_vModelText, _ctx.domReason]
                      ]),
                      (_ctx.errors?.path === 'holiday_cont')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(_ctx.errors.message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_155, [
                _hoisted_156,
                _createElementVNode("div", _hoisted_157, [
                  _createElementVNode("div", _hoisted_158, [
                    _createElementVNode("div", _hoisted_159, [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        rows: "5",
                        style: {"margin-bottom":"5px"},
                        disabled: _ctx.isEditMode,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.domRemarks) = $event))
                      }, "\n                      ", 8, _hoisted_160), [
                        [_vModelText, _ctx.domRemarks]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_161, [
                _hoisted_162,
                _createElementVNode("div", _hoisted_163, [
                  _createElementVNode("div", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        maxlength: "10",
                        value: _ctx.getAuthoriser(1),
                        disabled: ""
                      }, null, 8, _hoisted_166)
                    ]),
                    _hoisted_167,
                    _createElementVNode("div", _hoisted_168, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_1_approval,
                            _ctx.delegate.request.c_request_1_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_169)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_170, [
                _hoisted_171,
                _createElementVNode("div", _hoisted_172, [
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        maxlength: "10",
                        value: _ctx.getAuthoriser(2),
                        disabled: ""
                      }, null, 8, _hoisted_175)
                    ]),
                    _hoisted_176,
                    _createElementVNode("div", _hoisted_177, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_2_approval,
                            _ctx.delegate.request.c_request_2_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_178)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_179, [
                _hoisted_180,
                _createElementVNode("div", _hoisted_181, [
                  _createElementVNode("div", _hoisted_182, [
                    _createElementVNode("div", _hoisted_183, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtKouzaNumber",
                        class: "form-control form-control-sm",
                        maxlength: "10",
                        value: _ctx.getAuthoriser(3),
                        disabled: ""
                      }, null, 8, _hoisted_184)
                    ]),
                    _hoisted_185,
                    _createElementVNode("div", _hoisted_186, [
                      _createElementVNode("input", {
                        type: "text",
                        name: "txtStartDate",
                        class: "form-control form-control-sm",
                        value: 
                          _ctx.getAuthDate(
                            _ctx.delegate.request.c_request_3_approval,
                            _ctx.delegate.request.c_request_3_approval_datetime
                          )
                        ,
                        disabled: ""
                      }, null, 8, _hoisted_187)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[35] || (_cache[35] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _hoisted_188,
        _createElementVNode("span", _hoisted_189, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_190
      ]),
      footer: _withCtx(() => [
        _hoisted_191
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _hoisted_192,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_193
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_194, [
          _createElementVNode("button", {
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_disableConf" }, {
      title: _withCtx(() => [
        _hoisted_195,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDisableConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_196
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_197, [
          _createElementVNode("button", {
            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.disab())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.closeModal4disableConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_198,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_199
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_200, [
          _createElementVNode("button", {
            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ], 2))
}